export default {
  index: '/',
  workout: '/move/:userName/:workoutId',
};
